<template>

	<div class="full-img">
		<img :src="src" :class="classes" @load="loaded" />
	</div>

</template><script>

	export default {
		name: 'FullImg',
		props: [ 'src', 'align' ],
		data () {
			return { classes: [] }
		},
		methods: {
			loaded (e) {
				const el = e.target;
				// landscape
				if (el.width > el. height) {
					el.style.height = '100%';
					el.style.width = '';
				}
				// portrait
				else {
					el.style.height = '';
					el.style.width = '100%';
				}
			}
		},
		watch: {
			align: {
				immediate: true,
				handler (value) {
					value = value || '';
					this.classes = [
						value.includes('left') ? 'left' : value.includes('right') ? 'right' : 'center',
						value.includes('top') ? 'top' : value.includes('bottom') ? 'bottom' : 'middle'
					];
				}
			}
		}
	}

</script><style scoped>

	.full-img {
		position: relative;
		overflow: hidden;
	}
	img {
		position: absolute;
	}

	img.left { left: 0; }
	img.right { right: 0; }
	img.top { top: 0; }
	img.bottom { bottom: 0; }

	img.center { left: 50%; transform: translateX(-50%); }
	img.middle { top: 50%; transform: translateY(-50%); }
	img.center.middle { transform: translate(-50%, -50%); }

</style>
